import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, InputAdornment, MenuItem, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { editCouponData, getCustomerDetail } from "../../Api/Customer";
import { CustomerDetailInterface } from "../../Objects/Customer";
import MemberPoint from "../atoms/MemberPoint";
import CustomerCard from "../molecules/CustomerCard";

type CouponType = "plus" | "minus"

export interface CouponDataEditDialogProps {
    ctmId?: number
    dialogProps?: Omit<DialogProps, "open">
    onClose: () => void
}
export function CouponDataEditDialog({
    ctmId,
    dialogProps,
    onClose,
}: CouponDataEditDialogProps): React.ReactElement {
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)

    const [customerDetailData, setCustomerDetailData] = React.useState<CustomerDetailInterface>()

    const [editCoupon, setEditCoupon] = React.useState<number>(0)
    const [editCouponType, setEditCouponType] = React.useState<CouponType>("plus")

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (ctmId) {
            //validate
            // @todo
            editCouponData({
                ctm_id: ctmId,
                edit_point_value: editCouponType === "plus" ? editCoupon : editCoupon * -1,
            }, {signal: abortController.signal}).then(() => {
                enqueueSnackbar("登録しました", { variant: "success" })
                setOpen(false)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    }, [abortController, ctmId, editCoupon, editCouponType, enqueueSnackbar])

    React.useEffect(() => {
        const controller = new AbortController()
        if (ctmId) {
            getCustomerDetail({
                accessKey: "HEAD-OFFICE_LOGIN",
                ctmId: ctmId
            }, {signal: controller.signal}).then(result => {
                setCustomerDetailData(result)
                setEditCoupon(0)
                setOpen(true)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [ctmId, enqueueSnackbar])

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            TransitionProps={{
                onExited: () => {
                    onClose()
                }
            }}
        >
            <DialogTitle>ポイント編集</DialogTitle>
            {customerDetailData &&
                <DialogContent>
                    <CustomerCard
                        customer={customerDetailData}
                        additionalContent={<MemberPoint customerData={customerDetailData} />}
                    />
                    <Grid container
                        spacing={1}
                        rowSpacing={2}
                        mt={1}
                    >
                        <Grid item>
                            <TextField
                                value={editCouponType}
                                onChange={e => {
                                    setEditCouponType(e.target.value as CouponType)
                                }}
                                size="small"
                                select
                            >
                                <MenuItem value="plus">ポイントを加算</MenuItem>
                                <MenuItem value="minus">ポイントを減算</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item>
                            <TextField
                                value={editCoupon.toString()}
                                onFocus={(e) => {
                                    e.target.select();
                                }}
                                onChange={e => {
                                    if (e.target.value) {
                                        const cp = Number(e.target.value);
                                        if (!isNaN(cp)) {
                                            setEditCoupon(cp)
                                        }

                                    }
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">ポイント</InputAdornment>
                                }}
                                inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    min: 0
                                }}
                                size="small"
                                type={"number"}

                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            }
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setOpen(false)
                    }}
                >キャンセル</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        doSave()
                    }}
                >保存</Button>
            </DialogActions>
        </Dialog>
    )
}